import React from 'react';
import {
  Box, Container, Grid, Skeleton,
} from '@mui/material';
import StyledBox from 'views/rebranded-module/deals-module/DealsViewV2/components/PromotedDealSection/PromotedDealSection.styles';

const PromotedDealSectionSkeleton = () => (
  <StyledBox>
    <Container maxWidth="xxl">
      <Grid container spacing={8}>
        {/* Left side (info section) */}
        <Grid item lg={6} md={12} sm={12}>
          <Box className="PDSInfoSection">
            {/* Title skeleton */}
            <Skeleton variant="text" width="60%" height={50} />

            {/* Description skeleton */}
            <Skeleton variant="text" width="90%" height={30} />
            <Skeleton variant="text" width="80%" height={30} />

            {/* Button skeleton */}
            <Skeleton variant="rectangular" width={150} height={50} />
          </Box>
        </Grid>

        {/* Right side (image section) */}
        <Grid item lg={6} md={12} sm={12} className="PDSImageSide">
          <Box className="PDSImageContainer">
            {/* Main image skeleton */}
            <Skeleton variant="rectangular" width="100%" height="100%" />

            {/* Sub image skeleton */}
            <Box className="PDSSubImageContainer">
              <Skeleton variant="rectangular" width="100%" height="100%" />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  </StyledBox>
);

export { PromotedDealSectionSkeleton };
